import { lazy as lazyLoad } from 'react';

import { route } from './constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    SkillDetailsPage: lazyLoad(async () => {
        const { SkillDetailsPage } = await import('./SkillDetails');

        return { default: SkillDetailsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.skill-details.headlines.title',
        page: lazy.SkillDetailsPage,
        path: route.patterns.skillDetails,
    },
];
